import { useEffect, useState } from 'react';

const SIDEBAR_GUIDE_VISIBLE_UNTIL_STORAGE_KEY = 'fluxmind-sidebar-guide-visible-until';
const SIDEBAR_GUIDE_VISIBLE_DURATION_MS = 3 * 24 * 60 * 60 * 1000;

function readSidebarGuideEntryVisibility() {
  if (typeof window === 'undefined') {
    return true;
  }

  try {
    const now = Date.now();
    const storedValue = window.localStorage.getItem(SIDEBAR_GUIDE_VISIBLE_UNTIL_STORAGE_KEY)?.trim() || '';
    let visibleUntil = Number(storedValue);

    // 首次进入时写入 3 天有效期；异常值也按首次进入重新兜底。
    if (!Number.isFinite(visibleUntil) || visibleUntil <= 0) {
      visibleUntil = now + SIDEBAR_GUIDE_VISIBLE_DURATION_MS;
      window.localStorage.setItem(SIDEBAR_GUIDE_VISIBLE_UNTIL_STORAGE_KEY, String(visibleUntil));
    }

    return visibleUntil > now;
  } catch (error) {
    console.warn('Failed to read sidebar guide visibility state.', error);
    return true;
  }
}

export function useGuideEntry(pathname: string) {
  const [showGuideEntry, setShowGuideEntry] = useState(readSidebarGuideEntryVisibility);

  useEffect(() => {
    // 使用说明入口按首次进入后的 3 天有效期全局控制，避免切换到其他模块后重新常驻展示。
    setShowGuideEntry(readSidebarGuideEntryVisibility());
  }, [pathname]);

  return { showGuideEntry };
}
